import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("canvas", { class: "field" }, null, -1)
const _hoisted_4 = { class: "status_bar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "heading" }, "Информация", -1)
const _hoisted_6 = { class: "status_items" }
const _hoisted_7 = { class: "empty-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_item = _resolveComponent("status-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "start_button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startButtonClick()))
      }, "Новый путь")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_TransitionGroup, { name: "status_items" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths_status, (path) => {
              return (_openBlock(), _createBlock(_component_status_item, {
                key: path.id,
                path: path
              }, null, 8, ["path"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, "Начните новый путь!", 512), [
        [_vShow, !_ctx.paths_status.length]
      ])
    ])
  ]))
}